import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { LoginUser } from "../../Redux/actions/authentication";

import { Form, Input, Button, Checkbox, Spin } from "antd";
import { LoadingOutlined, UserOutlined } from "@ant-design/icons";
import "./styles.scss";

import ForgotPasswordModal from "../../components/ForgotPasswordModal";

export default function Login() {
  const dispatch = useDispatch();

  const { user } = useSelector(
    (state) => ({
      user: state.auth.user,
    }),
    shallowEqual
  );
  const [loading, setLoading] = useState(false);
  //add w/e for login here
  useEffect(() => {
    // if(!session) return Router.push('/login')
    // if(session) return Router.push('/dashboard')
  }, []);

  const handleSubmit = (values) => {
    dispatch(LoginUser(values));
  };

  const formRender = () => {
    // if(loading) return <div className='login-container'><Spin size={'large'} tip='Loading...'/></div>
    return (
      <div className="login-container">
        <Form onFinish={handleSubmit} className="login-form main-form">
          <img className="ng_logo" src={"/lalaandco_logo.png"}></img>
          <Form.Item
            name="email"
            className="form-item"
            rules={[{ required: true, message: "Please input your email!" }]}
            prefix={<UserOutlined />}
          >
            <Input
              placeholder="Email"
              disabled={loading}
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            className="form-item"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input
              type="password"
              placeholder="Password"
              disabled={loading}
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item className="form-item">
            {loading ? (
              <Spin size={"large"} tip="Loading..." />
            ) : (
              <Button type="primary" htmlType="submit" className="login-button">
                Login
              </Button>
            )}
          </Form.Item>
          {loading ? null : (
            <Button
              type="link"
              className="login-button"
              onClick={() => {
                window.location.href = "/register";
              }}
            >
              Register
            </Button>
          )}
          <ForgotPasswordModal />
        </Form>
      </div>
    );
  };

  return formRender();
}
